import { platformApiSlice } from "./platformApiSlice";

const normalizeScansResponse = (responseData) =>
  Array.isArray(responseData) ? responseData : [];

export const platformScansApiSlice = platformApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlatformScans: builder.query({
      query: ({ useProd = false }) => ({
        url: "/api/v1/scans/",
        params: { use_prod: useProd },
      }),
      providesTags: ["Scans"],
    }),
    getPlatformScanById: builder.query({
      query: ({ scanId, useProd = false }) => ({
        url: `/api/v1/scans/${scanId}`,
        params: { use_prod: useProd },
      }),
      providesTags: (result, error, { scanId }) => [
        { type: "Scans", id: scanId },
      ],
    }),
    getPlatformScansByWebsiteId: builder.query({
      query: ({ websiteId, useProd = false }) => ({
        url: `/api/v1/scans/website/${websiteId}`,
        params: { use_prod: useProd },
      }),
      transformResponse: normalizeScansResponse,
      providesTags: (result) =>
        result
          ? [
              ...result.map((scan) => ({
                type: "Scans",
                id: scan.scan_id || scan.id,
              })),
              "Scans",
            ]
          : ["Scans"],
    }),
    createPlatformScan: builder.mutation({
      query: ({ scan, useProd = false }) => ({
        url: "/api/v1/scans/",
        method: "POST",
        body: scan,
        params: { use_prod: useProd },
      }),
      invalidatesTags: ["Scans"],
    }),
    startPlatformScan: builder.mutation({
      query: ({ scan, useProd = false }) => ({
        url: "/api/v1/scans/start-scan",
        method: "POST",
        body: scan,
        params: { use_prod: useProd },
      }),
      invalidatesTags: ["Scans"],
    }),
    updatePlatformScan: builder.mutation({
      query: ({ scanId, scan, useProd = false, websiteId }) => ({
        url: `/api/v1/scans/${scanId}`,
        method: "PUT",
        body: scan,
        params: { use_prod: useProd, website_id: websiteId },
      }),
      invalidatesTags: (result, error, { scanId }) => [
        { type: "Scans", id: scanId },
        "Scans",
      ],
    }),
    deletePlatformScan: builder.mutation({
      query: ({ scanId, useProd = false }) => ({
        url: `/api/v1/scans/${scanId}`,
        method: "DELETE",
        params: { use_prod: useProd },
      }),
      invalidatesTags: ["Scans"],
    }),
    mergePlatformScans: builder.mutation({
      query: ({ scanIds, useProd = false }) => ({
        url: "/api/v1/scans/merge-scans",
        method: "POST",
        body: { scan_ids: scanIds },
        params: { use_prod: useProd },
      }),
      invalidatesTags: ["Scans"],
    }),
  }),
});

export const {
  useGetPlatformScansQuery,
  useGetPlatformScanByIdQuery,
  useGetPlatformScansByWebsiteIdQuery,
  useLazyGetPlatformScansByWebsiteIdQuery,
  useCreatePlatformScanMutation,
  useStartPlatformScanMutation,
  useUpdatePlatformScanMutation,
  useDeletePlatformScanMutation,
  useMergePlatformScansMutation,
} = platformScansApiSlice;
